import { useEffect, useCallback, useState } from 'react';
import Modal, { FullHeightModalContent } from '../../../components/Modal';
import { ParagraphLargeText } from '../../../components/Texts';
import PhoneVerificationForm from '../../../components/PhoneVerificationForm';
import {
  sendEvent,
  EVENT_VERIFY_PHONE_NUMBER_MODAL_SHOWN,
  EVENT_PHONE_VERIFIED,
} from '../../../common/analytics';

const VerifyPhoneNumberModal = ({ onClose, onContinue }) => {
  const [fullyRendered, setFullyRendered] = useState(false);

  useEffect(() => {
    sendEvent(EVENT_VERIFY_PHONE_NUMBER_MODAL_SHOWN);
  }, []);

  const handleVerified = useCallback(() => {
    sendEvent(EVENT_PHONE_VERIFIED);
    onContinue?.();
  }, [onContinue]);

  return (
    <Modal onClose={onClose} onDidPresent={() => setFullyRendered(true)}>
      <FullHeightModalContent>
        <ParagraphLargeText style={{ textAlign: 'center', width: '100%' }}>
          Deposit
        </ParagraphLargeText>
        <PhoneVerificationForm
          onVerified={handleVerified}
          showTitle={false}
        />
      </FullHeightModalContent>
    </Modal>
  );
};

export default VerifyPhoneNumberModal;
